import { render } from "./FooterConnect.vue?vue&type=template&id=4672412b&scoped=true"
const script = {}

import "./FooterConnect.vue?vue&type=style&index=0&id=4672412b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4672412b"]])

export default __exports__